const SvgModernize1 = (props) => (
  <>
    <defs />
    <path d="m0 0 192 192L0 384V0zM192 0l192 192-192 192V0z" fill={props.p10} />
  </>
);

export default SvgModernize1;
